import React, { Component } from 'react';
import homedata from '../../data/homedata.json';

class Services extends Component {
  render() {
    return (
      <section id="treatment" className="p-100px-tb sm-p-50px-b">
        <div className="container">

          {/* Section Heading */}
          <div className="row">
            <div className="col-sm-8 offset-sm-2">
              <div className="section-title text-center m-50px-b">
                <h2>{homedata.servicesSection.sectiontitle}</h2>
                <p>{homedata.servicesSection.sectionsubtitle}</p>
              </div>
            </div>
          </div>

          {/* Service Boxes */}
          <div className="row justify-content-md-center">
            {homedata.services.map((service, i) => {
              return (
                <div key={i} className="col-lg-4 col-md-6 d-flex">

                  {/* ✅ CUSTOM CLASS (NO THEME CONFLICT) */}
                  <div className="my-service-box text-center p-60px lg-p-40px md-p-30px sm-p-20px m-10px-t m-10px-b w-100 d-flex flex-column">

                    <i className={service.icon}></i>

                    <h4>{service.title}</h4>

                    <p>{service.content}</p>

                  </div>

                </div>
              );
            })}
          </div>

        </div>
      </section>
    );
  }
}

export default Services;